import React, { useState, useEffect } from 'react';
import { View } from 'react-native';
import { Indicator, ToolTip } from 'design-system';
import Text from 'design-system/Text';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { useCurrentPrice } from '../hooks/selectors';
import { formatAmount } from '../utils';
import { selectIsTradingAccountAlpaca } from '../reducers/selectors';
export const strings = {
    title: 'Amount (est.)',
    buyTitle: 'Total cost (est.)',
    latestPrice: 'Latest price: ',
    lastClosedPrice: 'Last close price: ',
    tooltipTitle: 'How is this estimated?',
    tooltipText: 'The amount you will sell for is based on the latest price – if the price has changed at the moment you place your order, the amount you sell for may change too. We’ll always sell at the best available price for as many shares as you enter.',
    tooltipTextSeccl: 'This amount you will sell for is based on the last close price – if the price has changed at the moment you place your order, the amount you sell for may change too. We’ll always sell at the best available price for as many shares as you enter.',
};
const AmountPreview = (props) => {
    const { assetId, latestPrice, amount, loading } = props;
    const isAlpacaAccount = useAppSelector(selectIsTradingAccountAlpaca);
    const currentPrice = useCurrentPrice(assetId);
    const [price, setPrice] = useState(() => {
        if (latestPrice)
            return latestPrice;
        return currentPrice ? { value: currentPrice.value, currency: currentPrice.currency } : null;
    });
    const colors = useColors();
    const styles = useStyles(styleSet);
    useEffect(() => {
        if (currentPrice) {
            setPrice(currentPrice);
        }
    }, [currentPrice]);
    if (price === null) {
        return null;
    }
    return (<View style={styles.container}>
      <View>
        <View style={styles.row}>
          <Text Text-14>{props.operation === 'buy' ? strings.buyTitle : strings.title}</Text>
          <Spacer w={4}/>
          <ToolTip title={strings.tooltipTitle} subtitle={isAlpacaAccount ? strings.tooltipText : strings.tooltipTextSeccl} colorKey="secondary" small offset={1}/>
        </View>
        <Text NumbersThin-14 Secondary>
          <Text TextThin-14 Secondary>
            {isAlpacaAccount ? strings.latestPrice : strings.lastClosedPrice}
          </Text>
          {formatAmount(price)}
        </Text>
      </View>
      <Spacer w={8}/>
      {loading ? (<Indicator style={styles.loadingIndicator} color={colors.text.secondary}/>) : (<Text Numbers-16 flex right numberOfLines={1}>
          {formatAmount(amount ?? { value: 0, currency: 'GBP' })}
        </Text>)}
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        height: rem(60),
        paddingHorizontal: rem(16),
        marginHorizontal: rem(16),
        borderRadius: rem(9),
        backgroundColor: colors.cards.onLight,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    loadingIndicator: {
        flex: 1,
        backgroundColor: 'transparent',
        alignItems: 'flex-end',
    },
}));
export default AmountPreview;
